import React from 'react';
import { FONT_BODY } from './theme';
import { Logo } from './ui';
import { LinkedInIcon, YouTubeIcon, XIcon, InstagramIcon } from './icons';

const FOOT_LINK: React.CSSProperties = {
  font: `500 13.5px ${FONT_BODY}`,
  color: '#475569',
  padding: '6px 11px',
};

const SiteFooter: React.FC<{ onTerms: () => void; onPrivacy: () => void }> = ({ onTerms, onPrivacy }) => (
  <footer style={{ borderTop: '1px solid #EDF3FC', background: '#FBFDFF', padding: 'clamp(20px,2.6vw,30px) clamp(16px,4vw,30px) 20px' }}>
    <div style={{ maxWidth: 1180, margin: '0 auto' }}>
      <div style={{ display: 'flex', gap: 22, alignItems: 'center', flexWrap: 'wrap' }}>
        <a href="#top" style={{ display: 'flex', alignItems: 'center', gap: 10, flex: 'none' }}>
          <Logo width={152} height={28} />
        </a>
        <nav style={{ display: 'flex', gap: 4, margin: '0 auto', flexWrap: 'wrap', justifyContent: 'center' }}>
          <a href="#top" className="sm1p-footer-link" style={FOOT_LINK}>
            About
          </a>
          <a href="#contact" className="sm1p-footer-link" style={FOOT_LINK}>
            Contact
          </a>
          <button
            type="button"
            onClick={onTerms}
            className="sm1p-footer-link"
            style={{ border: 0, background: 'none', cursor: 'pointer', ...FOOT_LINK }}
          >
            Terms &amp; Conditions
          </button>
          <button
            type="button"
            onClick={onPrivacy}
            className="sm1p-footer-link"
            style={{ border: 0, background: 'none', cursor: 'pointer', ...FOOT_LINK }}
          >
            Privacy Policy
          </button>
        </nav>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 7, flex: 'none' }}>
          <div style={{ display: 'flex', gap: 12 }}>
            <a href="#contact" aria-label="LinkedIn" className="sm1p-footer-link" style={{ color: '#64748B' }}>
              <LinkedInIcon />
            </a>
            <a href="#contact" aria-label="YouTube" className="sm1p-footer-link" style={{ color: '#64748B' }}>
              <YouTubeIcon />
            </a>
            <a href="#contact" aria-label="X" className="sm1p-footer-link" style={{ color: '#64748B' }}>
              <XIcon />
            </a>
            <a href="#contact" aria-label="Instagram" className="sm1p-footer-link" style={{ color: '#64748B' }}>
              <InstagramIcon />
            </a>
          </div>
          <span style={{ font: `400 12.5px ${FONT_BODY}`, color: '#64748B' }}>© 2026 SOOMUCH.AI. All rights reserved.</span>
        </div>
      </div>
      <p
        style={{
          font: `400 11.5px/1.55 ${FONT_BODY}`,
          color: '#64748B',
          margin: '16px 0 0',
          paddingTop: 14,
          borderTop: '1px solid #EDF3FC',
        }}
      >
        Platform and roadmap are free; charges apply only to selected third-party execution tools. Growth figures are
        targets the roadmap works toward, not guaranteed outcomes. Dashboard data shown is illustrative.
      </p>
    </div>
  </footer>
);

export default SiteFooter;
